<template>
    <div class="main">
        <div class="save">
            <!--
            <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            -->
        </div>
        <div class="clear"></div>
            <el-form ref="form" :model="form" :rules="rules" label-width="180px">
                  <el-form-item label="工时奖励" prop="workingHourReward" v-if="user.FID==-1">
                    <el-input v-model="form.workingHourReward"></el-input>
                </el-form-item>
                  <el-form-item label="效率比例参数(%)" prop="efficiencyPercent" v-if="user.FID==-1">
                    <el-input v-model="form.efficiencyPercent"></el-input>
                </el-form-item>
                <el-form-item label="效率奖励" prop="efficiencyReward" v-if="user.FID==-1">
                    <el-input v-model="form.efficiencyReward"></el-input>
                </el-form-item>
                <el-form-item label="指派人完成当天所有评价" prop="assignerEvaluate" v-if="user.FID==-1">
                    <el-input v-model="form.assignerEvaluate"></el-input>
                </el-form-item>
                <el-form-item label="审核通过奖励比例参数(%)" prop="auditPercent" v-if="user.FID==-1">
                    <el-input v-model="form.auditPercent"></el-input>
                </el-form-item>
                 <el-form-item label="全勤奖励" prop="attendanceReward" v-if="user.FID==-1">
                    <el-input v-model="form.attendanceReward"></el-input>
                </el-form-item>
            </el-form>

            <div class="save">
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
    </div>
</template>


<script>
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    export default {
        mixins: [mixin],
        data() {
            return {
                user : global.user,
                form: {workingHourReward:0,efficiencyPercent:0,efficiencyReward:0,auditPercent:0,attendanceReward:0,assignerEvaluate:0},
                rules: {
                    
                },
                loading:false
            }
        },
        methods: {
            save:function () {
                let url = "server/system/loginPic.ashx?cmd=Save"
                util.saveForm(url,this.$refs.form,this.form,this.loadFn("loading"),result=> {
                    util.msgSuc("保存成功")
                })
            }
        },
        created() {
            let _that = this
            let url = "server/system/LoginPic.ashx?cmd=GetOne"
            util.get(url,this.form,this.progressFn,result=> {
                    this.form.workingHourReward = result.workingHourReward
                    this.form.efficiencyPercent = result.efficiencyPercent
                    this.form.efficiencyReward = result.efficiencyReward
                    this.form.auditPercent =result.auditPercent
                    this.form.attendanceReward = result.attendanceReward
                    this.form.assignerEvaluate = result.assignerEvaluate
            })
        }
    }
</script>

<style scoped="">
    .main{
        margin: 10px 30px;
        width: 80%;
    }
   .save{
       float: right;margin:0 20px 10px 0
   }

    .clear{
        clear: both;
    }
</style>





// WEBPACK FOOTER //
// src/pages/system/Setting.vue